import { i18n as _i18n } from "@lingui/core";
import { useEffect, useState } from 'react';
import cx from 'classnames';
import { CheveronRightIcon } from '@wkda/icons';
import { LoadingButton } from '@wkda/styleguide';
import { useFormState } from 'react-final-form';
import { useWindowUnloadStatus } from '../hooks/useWindowUnloadStatus';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FormGlobalError = _ref => {
  let {
    className
  } = _ref;
  const {
    submitError,
    hasSubmitErrors
  } = useFormState({
    subscription: {
      error: true,
      submitError: true,
      hasSubmitErrors: true
    }
  });
  return hasSubmitErrors && submitError ? /*#__PURE__*/_jsx("div", {
    className: cx(className),
    children: /*#__PURE__*/_jsx("span", {
      className: "invalid-feedback",
      children: submitError
    })
  }) : null;
};
export function CarleadCreationButton(_ref2) {
  let {
    children = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.button'
    }),
    className,
    withGlobalError = true
  } = _ref2;
  const [clicked, setClicked] = useState(false);
  const {
    windowUnloaded
  } = useWindowUnloadStatus();
  const {
    submitting,
    submitSucceeded,
    submitFailed
  } = useFormState({
    subscription: {
      submitting: true,
      submitSucceeded: true,
      submitFailed: true
    }
  });
  const submittingProcess = (submitting || submitSucceeded) && !submitFailed;
  useEffect(() => {
    if (submitSucceeded) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [submitSucceeded]);
  useEffect(() => {
    if (submitFailed || submitSucceeded) {
      setClicked(false);
    }
  }, [submitFailed, submitSucceeded]);
  return /*#__PURE__*/_jsxs("div", {
    className: "carlead-creation-form-button__container",
    children: [/*#__PURE__*/_jsxs(LoadingButton, {
      variant: "secondary",
      type: "submit",
      onClick: () => setClicked(true),
      loading: clicked && submittingProcess && !windowUnloaded,
      size: "lg",
      className: cx('carlead-creation-form-button', className),
      "data-qa-selector": "carlead-submit-button",
      children: [children, /*#__PURE__*/_jsx(CheveronRightIcon, {
        className: "ml-2"
      })]
    }), withGlobalError ? /*#__PURE__*/_jsx(FormGlobalError, {
      className: "carlead-creation-form-button mb-2 mx-auto"
    }) : null]
  });
}